import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';

function FinancialMonthPicker({ financialMonth, setFinancialMonth, year, setYear }) {
  const financialYearStartMonth = 3; // April

  const initialDate = dayjs(`${year}-0${financialYearStartMonth + 1}-01`);

  const monthCellRender = (date) => {
    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ];
    const dateMonth = date.month(); // 0-based

    // Shift month based on financial year
    const financialMonthIndex = (dateMonth + financialYearStartMonth + 12) % 12;
    const displayMonthName = monthNames[financialMonthIndex];

    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%'
        }}
      >
        {displayMonthName}
      </div>
    );
  };

  const disabledDate = (current) => {
    if (!current) return false;

    const fyStartYear =
      current.month() + 1 >= financialYearStartMonth ? current.year() : current.year() - 1;

    const financialYearStart = dayjs(`${fyStartYear}-${financialYearStartMonth}-01`);
    const financialYearEnd = financialYearStart.add(1, 'year').subtract(1, 'month');

    return (
      current.isBefore(financialYearStart, 'month') || current.isAfter(financialYearEnd, 'month')
    );
  };

  const financialMonthChange = (value) => {
    if (!value) {
      setFinancialMonth(null);
      return;
    }

    const month = value.month();
    const financialMonthIndex = (month + financialYearStartMonth + 12) % 12;
    let financialYear = value.year();
    if ([0, 1, 2].includes(financialMonthIndex)) {
      financialYear = value.year() + 1;
    }

    // Manipulate value to represent the "financial" version
    const manipulatedValue = value
      .set('year', financialYear)
      .set('month', financialMonthIndex)
      .set('date', 1);

    setFinancialMonth(manipulatedValue);

    setYear(financialYear);
  };

  const handleOpen = (open) => {
    if (!open) return;
    if (year) {
      setFinancialMonth(initialDate);
    }
  };

  useEffect(() => {
    if (year && !financialMonth) {
      setFinancialMonth(null);
    }
  }, [year, financialMonth]);

  return (
    <DatePicker
      style={{ width: '100%', margin: '12px 0' }}
      picker="month"
      size="middle"
      onChange={financialMonthChange}
      monthCellRender={monthCellRender}
      disabledDate={disabledDate}
      value={financialMonth}
      onOpenChange={handleOpen}
    />
  );
}

FinancialMonthPicker.propTypes = {
  setFinancialMonth: PropTypes.func.isRequired,
  financialMonth: PropTypes.instanceOf(Object),
  year: PropTypes.number,
  setYear: PropTypes.func.isRequired
};

FinancialMonthPicker.defaultProps = {
  financialMonth: {},
  year: null
};

export default FinancialMonthPicker;
